import { computed } from '@vue/composition-api';
import Article from '@/orm/models/Company/Article';

export default function useArticle() {
  const articles = computed(() => Article.query().withAllRecursive().get());

  async function fetchAll(companyId) {
    await Article.api().fetchAll(companyId);
  }

  async function createArticle(payload) {
    const response = await Article.api().store(payload);
    return response.response.data.data;
  }

  async function setPreview(articleId, payload) {
    await Article.api().setPreview(articleId, payload);
  }

  async function deleteArticle(articleId) {
    await Article.api().deleteArticle(articleId);
    await Article.delete(articleId);
  }

  async function fetchArticle(articleId) {
    await Article.api().fetchArticle(articleId);
    return Article.query().withAllRecursive().find(articleId);
  }

  async function updateArticle(articleId, payload) {
    await Article.api().updateArticle(articleId, payload);
    return Article.query().withAllRecursive().find(articleId);
  }

  async function publishArticle(articleId, payload) {
    await Article.api().publish(articleId, payload);
  }

  async function removePublication(articleId) {
    await Article.api().removePublication(articleId);
  }

  return {
    articles,
    fetchAll,
    createArticle,
    setPreview,
    deleteArticle,
    fetchArticle,
    updateArticle,
    publishArticle,
    removePublication,
  };
}
